<template>
  <div>
    <vx-card title="Информация о бронировании" class="mb-8">
      <div class="vx-row">
        <div class="vx-col flex-1">
          <table class="w-3/5">
            <tr>
              <td class="font-semibold">Номер бронирования</td>
              <td class="pl-4">
                <span class="text-primary">#{{ reservation.id }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Дата создания</td>
              <td class="pl-4">
                <span class="text-primary">{{ reservation.date_created }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Статус</td>
              <td class="pl-4 w-2/5">
                <span class="text-primary">{{
                  reservation.is_cancelled ? "Отменен" : "Не отменен"
                }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Оплачен</td>
              <td class="pl-4 w-2/5">
                <span class="text-primary">{{
                  reservation.is_paid ? "Оплачен" : "Не оплачен"
                }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Стоимость</td>
              <td class="pl-4">
                <span class="text-primary">{{ reservation.price }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Количество билетов</td>
              <td class="pl-4">
                <span class="text-primary">{{
                  reservation.ticket_quantity
                }}</span>
              </td>
            </tr>
          </table>
        </div>

        <div class="vx-col flex-1">
          <table>
            <tr>
              <td class="font-semibold">Автор заявки</td>
              <td class="pl-4">
                <span v-if="reservation.user" class="text-primary">{{
                  reservation.user.full_name
                }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Номер телефона</td>
              <td class="pl-4">
                <a
                  v-if="reservation.user"
                  :href="`tel:${reservation.user.phone}`"
                  class="text-primary"
                  >{{ reservation.user.phone }}</a
                >
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Адрес</td>
              <td class="pl-4">
                <span class="text-primary"
                  >{{ reservation.user.homes[0].county_type.name }}, ул.
                  {{ reservation.user.homes[0].address }}</span
                >
              </td>
            </tr>

            <tr>
              <td class="font-semibold">Мероприятие</td>
              <td class="pl-4">
                <p class="mb-1">
                  Категория:
                  <span class="text-primary">{{
                    reservation.event.category.name
                  }}</span>
                </p>
                <p class="mb-1">
                  Название:
                  <span class="text-primary">{{ reservation.event.name }}</span>
                </p>
                <p class="mb-1">
                  Дата и время проведения:
                  <span class="text-primary"
                    >{{ reservation.event.date_start }} -
                    {{ reservation.event.date_end }}</span
                  >
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <template slot="footer">
        <vs-button
          :disabled="reservation.is_cancelled"
          @click="cancelReservation"
          class="mr-3"
          color="warning"
          type="filled"
          >Отменить бронь</vs-button
        >
        <vs-button @click="popupDeleteComfirm = true" color="danger">
          Удалить
        </vs-button>
      </template>
    </vx-card>
    <vs-popup
      title="Вы действительно хотите удалить?"
      :active.sync="popupDeleteComfirm"
    >
      <p class="font-semibold mb-5">
        Заявка <span class="text-danger text-lg">#{{ reservation.id }}</span>
        будет удалена безвозвратно
      </p>
      <vs-button
        @click="deleteReservation"
        color="danger"
        class="mr-5"
        type="filled"
        >Удалить</vs-button
      >
      <vs-button @click="popupDeleteComfirm = false" color="dark" type="border"
        >Отмена</vs-button
      >
    </vs-popup>
  </div>
</template>

<script>
import { API_URL, statusType, countyType } from "@/.env";

import { DateTime } from "luxon";

export default {
  data: () => ({
    reservation: [],

    statusType,
    countyType,
    BASE_URL: API_URL,
    popupDeleteComfirm: false,
  }),
  components: {},
  watch: {
    "$route.params.id": {
      handler: function (id) {
        this.getTicket(id);
      },
    },
  },
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    cancelReservation() {
      this.$load(async () => {
        let res = (await this.$api.booking.cancelOrder(this.$route.params.id))
          .data;

        this.reservation.is_cancelled = true;

        this.notification("Успешно", "Бронь успешно отменена", "success");
      });
    },
    getBooking(id) {
      this.$load(async () => {
        let res = (await this.$api.booking.getOrder(id)).data;

        res.user.homes[0].county_type = this.countyType.find(
          (x) => x.id == res.user.county_type
        );

        res.event.date_start = DateTime.fromISO(res.event.date_start).toFormat(
          "dd.MM.yyyy HH:mm"
        );

        res.event.date_end = DateTime.fromISO(res.event.date_end).toFormat(
          "dd.MM.yyyy HH:mm"
        );

        this.reservation = res;
      });
    },
    deleteReservation() {
      this.$load(async () => {
        await this.$api.booking
          .deleteOrder(this.reservation.id)
          .then((response) => {
            if (response.status == 200) {
              this.popupDeleteComfirm = false;
              this.notification(
                "Успешно",
                `Заявка на бронирование удалена`,
                "success"
              );
            }
          })
          .catch((error) => {
            this.notification(
              "Ошибка",
              `Не удалось удалить заявку на бронирование`,
              "danger"
            );
          });

        this.$router.push({ name: "requests" });
      });
    },
  },
  created() {},
  mounted() {
    this.getBooking(this.$route.params.id);
  },
};
</script>